/***
 * 私有指令实体组件
 * zxw
 * 2024-04-07
 */

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Segmented,
    Row,
    Col,
    message,
    Input,
    Button,
    Popover,
} from 'antd';
import { BlockOutlined, SwitcherOutlined } from '@ant-design/icons';
import $ from 'jquery';
import {
    winWidth,
    AddRequestHeaders,
    winHeight,
    UjoinParams,
    FormatCommandContent,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '指令仓库';

const CommandPublicItem = (props) => {
    const [isHover, setIsHover] = useState(false);

    /**
     * 创建收藏
     */
    const _create = () => {
        $.ajax({
            url: `${CNF.api}command/collects`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'command_ulid': props.data.key,
            }), success: function (data) {
                if (data.res === 0) {
                    message.success(data.msg, CNF.messageDuration);
                    // 刷新指令库界面
                    props.refreshCommands(props.data.key, data.dat.command_collect_ulid);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 删除收藏
     */
    const _delete = () => {
        $.ajax({
            url: `${CNF.api}command/collects/${props.data.command_collect_ulid}`,
            headers: AddRequestHeaders(),
            type: 'DELETE',
            success: function (data) {
                if (data.res === 0) {
                    message.success(data.msg, CNF.messageDuration);
                    if (props.tag === '我的收藏') {
                        //  刷新收藏指令
                        props.getCommandCollects();
                    } else {
                        //  在“场景”和“角色”标签页下，刷新界面
                        props.refreshCommands(props.data.key, "");
                    }

                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    return <div style={{
        cursor: 'pointer',
        width: 'calc(100% - 30px)',
        background: '#F5F5F5',
        borderRadius: 5,
        height: 140,
        padding: 15,
        boxShadow: isHover ? '0 3px 3px 6px rgba(245,245,245,0.5)' : '',
    }} onMouseEnter={() => { setIsHover(true); }}
        onMouseLeave={() => { setIsHover(false); }}
    >
        <div style={{ height: 30, lineHeight: '30px' }}>
            <div style={{
                display: 'inline-block',
                width: 'calc(100% - 35px)',
                fontSize: 16,
                fontWeight: 'bold',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
            }}>
                {props.data.title}
            </div>
            <div style={{ display: 'inline-block', float: 'right', width: '30px', height: 30, }}>
                <Popover placement="top" title={null} content={props.data.command_collect_ulid ? '取消收藏' : '点击收藏'}>
                    <Button onClick={(e) => {
                        props.data.command_collect_ulid ? _delete() : _create();
                        e.preventDefault();
                    }} type='text' style={{
                        display: props.data.command_collect_ulid ? 'inline-block' : isHover ? 'inline-block' : 'none',
                        background: props.data.command_collect_ulid ? '#d9d9d9' : '',
                        color: props.data.command_collect_ulid ? '#FF904D' : '',
                    }} icon={<BlockOutlined />} />
                </Popover>
            </div>
        </div>
        <div style={{
            marginTop: 10,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            height: 60,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            maxHeight: '3.0em',
            lineHeight: '1.5em',
            maxHeight: '3em',
        }}>{
                props.data.content.replace(/\]/g, '\[').split('\[').map((item, key) => {
                    if (key % 2 === 0) {
                        return item;
                    } else {
                        return FormatCommandContent(item);
                    }
                })
            }</div>
        <div style={{
            marginTop: 20,
            height: 30,
            borderTop: '1px solid #FF904D',
            textAlign: 'right',
            paddingTop: 10,
        }}>
            {
                isHover ? <Button onClick={(e) => {
                    props.setMessages(props.data.content);
                    props.setIsCommand(false);                  //  退出指令调用
                    props.setIsHover(false);                    //  退出指令悬浮
                    props.setPublicCommandInfo(props.data);     //  发送指令信息
                    props.cancel();                             //  退出指令仓库
                    document.getElementById('chat-question-id') && document.getElementById('chat-question-id').focus()
                    props.senderRef && props.senderRef.current.focus({ cursor: 'end', });   //  输入框获取焦点
                    e.preventDefault();
                }} type='primary'>使用</Button> : <SwitcherOutlined style={{ fontSize: 15 }} />
            }
        </div>
    </div>
}

const CommandPublicEntry = (props) => {
    const [_props, setProps] = useState(props);
    const [title, setTitle] = useState('');                         //  指令搜索标题  
    const [tag, setTag] = useState('场景');                          //  导航标签
    const [sceneTags, setSceneTags] = useState([]);                 //  场景标签
    const [roleTags, setRoleTags] = useState([]);                   //  角色标签
    const [currentTags, setCurrentTags] = useState([]);             //  当前标签
    const [selectTag, setSelectTag] = useState('');                 //  选中标签
    const [pageSize, setPageSize] = useState(CNF.pageSize * 2);     //  分页大小
    const [commands, setCommands] = useState([]);
    const [scrollHeight, setScrollHeight] = useState(0);            //  滚动条高度

    //  切换导航标签
    useEffect(() => {
        if (tag === '场景' && sceneTags.length < 1) {
            getTags();
        }
        if (tag === '场景' && sceneTags.length > 0) {
            setCurrentTags(sceneTags);
            setSelectTag(sceneTags[0].name);        //  默认选中第一个
        }
        if (tag === '角色' && roleTags.length < 1) {
            getTags();
        }
        if (tag === '角色' && roleTags.length > 0) {
            setCurrentTags(roleTags);
            setSelectTag(roleTags[0].name);         //  默认选中第一个
        }
        if (tag === '我的收藏') {   //  我的收藏  
            getCommandCollects();
            setSelectTag('');   //  清空已选标签
        }
    }, [tag]);

    //  获取指令
    useEffect(() => {
        if (selectTag && tag !== '我的收藏') {
            getCommandPublics();
        }
    }, [selectTag]);

    useEffect(() => {
        setProps(props);
    }, [props]);

    const cancel = () => {
        setProps(false);
    };

    /**
     * 刷新指令信息
     * @param {*} commandUlid 
     * @param {*} commandCollectUlid 
     */
    const refreshCommands = (commandUlid, commandCollectUlid) => {
        let _commands = commands;
        for (let i = 0; i < _commands.length; i++) {
            if (_commands[i].key === commandUlid) {
                _commands[i].command_collect_ulid = commandCollectUlid;
                setCommands(_commands);
                break;
            }
        }
    }

    /**
     * 获取导航标签
     */
    const getTags = () => {
        var params = {
            rss: tag === '场景' ? 'scene' : 'role'
        }
        $.ajax({
            url: `${CNF.api}command/publics${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    //  获取对应标签
                    tag === '场景' ? setSceneTags(data.dat) : setRoleTags(data.dat);
                    setCurrentTags(data.dat);   //  赋予当前标签
                    if (data.dat.length > 0) {
                        setSelectTag(data.dat[0].name);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 获取公共指令
     */
    const getCommandPublics = () => {
        var params = {
            title: title,
            role: tag === '场景' ? '' : selectTag,
            scene: tag === '场景' ? selectTag : '',
            status: CNF.status[0].value,
            page_size: pageSize,
        }
        $.ajax({
            url: `${CNF.api}command/publics${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    //  获取指令
                    setCommands(data.dat);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 获取收藏指令
     */
    const getCommandCollects = () => {
        var params = {
            title: title,
            role: tag === '场景' ? '' : selectTag,
            scene: tag === '场景' ? selectTag : '',
            status: CNF.status[0].value,
            page_size: pageSize,
        }
        $.ajax({
            url: `${CNF.api}command/collects${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    //  获取指令
                    setCommands(data.dat);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    return <ConfigProvider
        theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}
    >
        <Modal
            width={winWidth * 2 / 3}
            height={winHeight}
            title={MODULENAME}
            open={_props.isModalOpen}
            onCancel={cancel}
            keyboard={true}
            footer={null}
            style={{ top: 0, }}
        >
            <div>
                <div style={{ background: '#F5F5F5', padding: 5, borderRadius: 5, }}>
                    <Row>
                        <Col span={7}>
                            <Segmented
                                options={['场景', '角色', '我的收藏']}
                                onChange={(value) => {
                                    setTag(value);
                                }}
                            />
                        </Col>
                        <Col span={6}>
                            <Input
                                placeholder='搜索'
                                value={title}
                                onChange={(e) => { setTitle(e.target.value) }}
                                style={{ width: '100%', boxShadow: 'none', borderColor: '#F5F5F5' }}
                                onPressEnter={(e) => {
                                    if (tag === '我的收藏') {
                                        getCommandCollects();
                                    } else {
                                        getCommandPublics();
                                    }
                                    e.preventDefault();
                                }}
                            />
                        </Col>
                    </Row>
                </div>
                {
                    tag === '场景' || tag === '角色' ?
                        <div>
                            {
                                currentTags && currentTags.map((item) => {
                                    return <Button key={item.name} type={selectTag === item.name ? 'primary' : 'default'}
                                        style={{ margin: '10px 10px 0 0', }} onClick={(e) => {
                                            setSelectTag(item.name);
                                            e.preventDefault();
                                        }}>{item.name}</Button>
                                })
                            }
                        </div>
                        :
                        <div></div>
                }
                <div style={{
                    maxHeight: winHeight - 157,
                    scrollbarColor: '#d9d9d9 transparent',
                    scrollbarWidth: 'thin',
                    overflowY: 'auto',
                    paddingRight: 24,
                    marginRight: -24
                }} onScroll={(e) => {
                    let d = e.target;
                    let clientHeight = d.clientHeight;   //  div高度
                    let _scrollHeight = d.scrollHeight;  //  滚动条高度
                    let scrollTop = d.scrollTop;         //  滚动条离顶部的高度
                    if (scrollTop + clientHeight === _scrollHeight && _scrollHeight > scrollHeight) {
                        //  设置滚动条高度
                        setScrollHeight(_scrollHeight);
                        //  调用接口拉数据
                        setPageSize(pageSize + CNF.pageSize);
                    }
                }}>
                    <Row>
                        {
                            commands && commands.map((item, key) => {
                                let m = (key + 1) % 4;
                                return <Col span={6} style={{
                                    paddingRight: m === 1 ? 12 : m === 2 ? 8 : m === 3 ? 4 : 0,
                                    paddingLeft: m === 1 ? 0 : m === 2 ? 4 : m === 3 ? 8 : 12,
                                    paddingTop: 15
                                }} key={key}><CommandPublicItem
                                        tag={tag}
                                        data={item}
                                        refreshCommands={refreshCommands}
                                        getCommandCollects={getCommandCollects}
                                        setMessages={props.setMessages}
                                        setIsCommand={props.setIsCommand}
                                        setIsHover={props.setIsHover}
                                        setPublicCommandInfo={props.setPublicCommandInfo}
                                        cancel={cancel}
                                    /></Col>
                            })
                        }
                    </Row>
                </div>
            </div>
        </Modal>
    </ConfigProvider>
}

export default CommandPublicEntry;